<main class="dialog-edit-user">
    <div>
        <h1
            mat-dialog-title class="dialog-edit-user__title">
            {{"EditUser" | translate}}
        </h1>

        <ng-template #loading>
          <div class="loading-container">
            <div  class="pulsing">
              <mat-spinner [diameter]="50" ></mat-spinner>
            </div>
            <p class="pulsing">{{"Loading" | translate}}</p>
          </div>
        </ng-template>

        <div mat-dialog-content class="dialog-edit-user__content" *ngIf="graphDropdowns$ | async as graphDropdowns; else loading">
          <form [formGroup]="editUserForm" >
            <div class="email-content"  *ngIf="helperService.user.role.roleId === 7">
            <div>
              <p>{{"UserIncadea" | translate}}</p>
            </div>
            <div class="col-lg-6">
              <mat-radio-group aria-label="Select an option"   [disabled]="editUserForm.value.Ismixto === 1" class="radio-group" formControlName="IsIncadea"  (change)="onRadioChange($event)">
                <mat-radio-button [value]=1 labelPosition="before"  class="radio-button" >{{"Yes" | translate}}</mat-radio-button>
                <mat-radio-button [value]=0  labelPosition="before" class="radio-button" >{{"No" | translate}}</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>

            <div class="email-content">
              <h3 mat-dialog-subtitle class="dialog-edit-user__subtitle">
                  {{"InstitutionalEmail" | translate}}
              </h3>
              <h3 mat-dialog-subtitle class="dialog-email">
                  {{user.email}}
              </h3>
            </div>


            <div
              class="dialog-edit-user_country"
              *ngIf="helperService.user.role.roleId === 4"
            >
              <h3 mat-dialog-subtitle class="dialog-edit-user__subtitle">
                {{"Country" | translate}} :
              </h3>
              <h3 mat-dialog-subtitle class="dialog-edit-user_country_name">
                {{user.countryName}}
              </h3>
            </div>
            <br/>

            <div class="dialog-edit-user__wrapper">

                <div>
                  <mat-form-field>
                    <mat-label class="dialog-edit-user__label"
                      >{{"FirstName" | translate}}</mat-label
                    >
                    <input matInput
                    oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                      type="text"
                      formControlName="FirstName"
                      maxlength="20"/>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field>
                    <mat-label class="dialog-edit-user__label"
                      >{{"LastName" | translate}}</mat-label
                    >
                    <input
                      matInput
                      oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                      type="text"
                      formControlName="LastName"
                      maxlength="20"
                    />
                  </mat-form-field>
                </div>

                <div *ngIf="helperService.user.role.roleId === 7">
                  <mat-form-field>
                    <mat-label class="dialog-edit-user__label">
                      {{"Country" | translate}}
                    </mat-label>
                    <mat-select formControlName="CountryName">
                      <mat-option *ngFor="let country of graphDropdowns[0][0]"
                        [value]="country.CountryId"
                        (click)="selectCountry(country.CountryId)"
                        >
                        {{country.CountryName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div >
                  <mat-form-field>
                    <mat-label class="dialog-edit-user__label">
                      {{"Language" | translate}}
                    </mat-label>
                    <mat-select formControlName="Language">
                      <mat-option *ngFor="let userLanguage of languages"
                        [value]="userLanguage.codeLanguage"
                        >
                        {{ userLanguage.nameLanguage | translate }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div *ngIf="helperService.user.role.roleId === 4">
                    <mat-form-field>
                      <mat-label class="dialog-edit-user__label">
                        {{"Role" | translate}}
                      </mat-label>
                      <mat-select formControlName="UserRole">
                        <mat-option *ngFor="let role of graphDropdowns[0][0]"
                            [value]="role.RoleId"
                            (click)="selectRoleId(role.RoleId)"
                          >
                          {{role.RoleName  | translate }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>

                <div *ngIf="helperService.user.role.roleId === 7">
                  <mat-form-field>
                    <mat-label class="dialog-edit-user__label">
                      {{"Role" | translate}}
                    </mat-label>
                    <mat-select formControlName="UserRole">
                      <mat-option *ngFor="let role of graphDropdowns[0][1]"
                          [value]="role.RoleId"
                          (click)="selectRoleId(role.RoleId)"
                        >
                        {{role.RoleName}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div
                  *ngIf="ownerRoleId === 7 &&
                        (editUserForm.value.UserRole === 1 ||
                        editUserForm.value.UserRole === 2 ||
                        editUserForm.value.UserRole === 6 ||
                        editUserForm.value.UserRole === 4 ) && editUserForm.value.IsIncadea !== 1"
                >
                    <mat-form-field>
                      <mat-label class="dialog-edit-user__label">
                        {{"RetailName" | translate}}
                      </mat-label>

                      <mat-select
                        formControlName="RetailName"
                      >
                        <mat-option
                        *ngFor="let retail of retailSelected$ | async "
                        [value]="retail.RetailId"
                        (click)="selectRetail(retail.RetailId)"
                        >
                        {{retail.RetailGroupName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>
                <div
                  *ngIf="ownerRoleId === 7 && editUserForm.value.UserRole === 4  && editUserForm.value.IsIncadea === 1"
                >
                <mat-form-field>
                  <mat-label class="dialog-edit-user__label"
                    >CompanyId</mat-label
                  >
                  <input
                    matInput
                    oninput="value = value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚüÜ ñÑ.,]/g, '')"
                    type="text"
                    formControlName="CompanyId"
                    maxlength="50"
                  />
                </mat-form-field>
                </div>

                <div
                  *ngIf="editUserForm.value.UserRole === 1 ||
                        editUserForm.value.UserRole === 2 ||
                        editUserForm.value.UserRole === 6"
                >
                    <mat-form-field>
                      <mat-label class="dialog-edit-user__label">
                        {{"WorkshopName" | translate}}
                      </mat-label>
                      <mat-select formControlName="WorkshopName">
                        <mat-option *ngFor="let role of workshopSelected$ | async"
                            [value]="role.WorkshopId"
                            (click)="selectworkshop(role.WorkshopId)">
                          {{ role.WorkshopName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>

                  <div *ngIf="editUserForm.value.UserRole === 1" >
                    <mat-form-field>
                      <mat-label  class="dialog-edit-user__label">
                        {{"Advisor" | translate}}
                      </mat-label>

                      <mat-select
                        formControlName="AdvisorName"
                      >
                        <mat-option
                        *ngFor="let advisor of advisorSelected$ | async "
                        [value]="advisor.AdvisorId"
                        >
                        {{advisor.AdvisorFullName}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

            </div>
            <div class="email-content"  *ngIf="editUserForm.value.UserRole === 3">
              <div>
                <p>{{"UserMixtoIncadeaBooking" | translate}}</p>
              </div>
              <div class="col-lg-6">
                <mat-radio-group aria-label="Select an option"  class="radio-group" formControlName="Ismixto" (change)="onRadioChangeMixto($event)">
                  <mat-radio-button [value]=1 labelPosition="before"  class="radio-button">{{"Yes" | translate}}</mat-radio-button>
                  <mat-radio-button [value]=0  labelPosition="before" class="radio-button">{{"No" | translate}}</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <h2 class="dialog-edit-user__subtitle">
              {{ "SelectStatusUser" | translate }}
            </h2>

            <td style="width: 15%; font-size: 14px; text-align: center">
                <mat-label
                  *ngFor="let state of userDataSelected"
                  class="switch-right-label"
                > {{state.IsActive
                  ? ('Active' | translate | capitalize)
                  : ('Inactive' | translate | capitalize)}}
                  <mat-slide-toggle
                    size="small"
                    class="custom-switch"
                    formControlName="IsActive"
                    [(ngModel)]="state.IsActive"
                  ></mat-slide-toggle>
                </mat-label>
            </td>
            
          </form>
        </div>

        
        <div *ngIf="!isLoadingSave">
          <section class="dialog-loading-container">
            <div  class="pulsing">
              <mat-spinner [diameter]="50" ></mat-spinner>
            </div>
            <p class="pulsing">{{"Loading" | translate}}</p>
          </section>
        </div>

        <mat-dialog-actions
          align="center"
          [ngClass]="{'disabled-content': !isLoadingSave}"
        >
            <button class="dialog__button" [mat-dialog-close]>
              {{"Cancel" | translate}}
            </button>
            <button
              class="dialog__button"
              [ngClass]="editUserForm.invalid ? 'dialog__button--disabled' : 'dialog__button--fill'"
              (click)="onSaveEditUser()"
              [disabled]= "formsValidations() "
            >
              {{"Accept" | translate}}
            </button>
        </mat-dialog-actions>
    </div>
</main>
